import * as Sentry from '@sentry/browser';

const awsApiHost = process.env.CLEARDATA_API_HOST;
const dataDogPath = '/metrics/v1/monitoring';

const dataDogUtils = async (event) => {
    try {
        const metrics = { events: [event] };

        await fetch(`${awsApiHost}${dataDogPath}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(metrics),
            credentials: 'omit',
        });
    } catch (error) {
        if (typeof window !== 'undefined') {
            const { SENTRY_DSN } = window && window.ZD ? window.ZD.configs : {};
            if (SENTRY_DSN) {
                Sentry.withScope((scope) => {
                    scope.setExtras({
                        message: 'error logging metric to data dog',
                        event,
                    });
                    scope.setLevel(Sentry.Severity.Warning);
                    scope.setFingerprint(['error logging metric to data dog']);
                    Sentry.captureException(error);
                });
            }
        }
    }
};

/**
 * This increments a metric in DataDog.
 * Tags can either be an object of key value
 * pairs, or an array of strings, as such:
 * ['myTagKey:myTagValue', 'anotherTagKey:anotherTagValue']
 *
 * @param {string} name
 * @param {object|string[]} tags
 *
 */
export const increment = async ({ name, tags = [] }) =>
    await dataDogUtils({ name, type: 'increment', tags });

/**
 * This sends histogram metric to DataDog.
 * Tags must be an array of strings, as such:
 * ['myTagKey:myTagValue', 'anotherTagKey:anotherTagValue']
 *
 * @param {string} name - metric name
 * @param {number} value - numerical value to attach to histogram
 * @param {string[]} tags - tags to attach to metric
 *
 */
export const histogram = async ({ name, value = 1, tags = [] }) =>
    await dataDogUtils({
        name,
        type: 'histogram',
        value,
        tags,
    });
